/*
  ZR EMAIL CAPTURE - bar + popup behaviour (change q4-email-capture-funnel).
  Loaded by sections/zr-email-bar.liquid and sections/zr-email-popup.liquid;
  runs once even when both include it.

  Rules (gates EC-G2..EC-G6):
  - never on first paint: auto-open needs >= scroll percent depth (50%, after the
    optional delay, default 0 s), or a desktop exit-intent (pointer leaves through
    the top edge) after 3 s - Thanh 2026-10-20. Phones expose no exit signal;
    they get the scroll trigger only;
  - never while the Shopify cookie-consent banner is visible;
  - auto-opens only on the homepage, collections and content pages; never on
    product, cart, account, challenge or password pages (the bar still opens it
    there on tap - an explicit request);
  - close = X, "No thanks", backdrop or Escape; remembered dismiss_days;
    a sign-up is remembered 365 days and hides the bar;
  - focus moves into the dialog, Tab cycles inside it while open, focus
    returns to the opener on close.
  Storage: localStorage key zr_ec_v1 = {dismissed, joined, barHidden} (ms).
  If storage throws, the popup does not auto-open (it could not remember a close).
*/
(function () {
  'use strict';
  if (window.ZrEmailPopup) return;

  var KEY = 'zr_ec_v1';
  var DAY = 864e5;
  // Auto-open only on the homepage and landing pages (collections incl. interest hubs,
  // content pages) - Thanh 2026-10-20. PDP, cart, account etc. never auto-open.
  var AUTO_PAGES = /^(index|collection|page)$/;

  function load() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return null; }
  }
  function save(patch) {
    try {
      var s = load() || {};
      for (var k in patch) { if (Object.prototype.hasOwnProperty.call(patch, k)) s[k] = patch[k]; }
      window.localStorage.setItem(KEY, JSON.stringify(s));
      return true;
    } catch (e) { return false; }
  }
  function visible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function consentOpen() {
    return visible(document.getElementById('shopify-pc__banner'));
  }

  var root, dialog, formView, doneView, form, lastFocus = null, isOpen = false;

  function hideBar() {
    var bars = document.querySelectorAll('[data-zr-ec-bar]');
    for (var i = 0; i < bars.length; i++) bars[i].hidden = true;
  }

  function focusables() {
    var list = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < list.length; i++) { if (list[i].getClientRects().length) out.push(list[i]); }
    return out;
  }

  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('escape'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); dialog.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === dialog || !dialog.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !dialog.contains(a))) { e.preventDefault(); first.focus(); }
  }

  function showView(name) {
    formView.hidden = name !== 'form';
    doneView.hidden = name !== 'done';
  }

  function open(opts) {
    if (!root || isOpen) return;
    opts = opts || {};
    lastFocus = opts.opener || document.activeElement;
    showView(opts.view || 'form');
    root.hidden = false;
    root.setAttribute('data-state', 'open');
    document.documentElement.classList.add('zr-ec-lock');
    isOpen = true;
    document.addEventListener('keydown', onKey, true);
    var target = (opts.view === 'done') ? doneView.querySelector('[data-zr-ec-done-title]') : dialog;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }

  function close(reason) {
    if (!isOpen) return;
    isOpen = false;
    root.hidden = true;
    root.removeAttribute('data-state');
    document.documentElement.classList.remove('zr-ec-lock');
    document.removeEventListener('keydown', onKey, true);
    var s = load();
    if (s && !s.joined) save({ dismissed: Date.now() });
    if (lastFocus && lastFocus.focus && document.contains(lastFocus) && lastFocus !== document.body) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
    } else if (document.activeElement && dialog.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    lastFocus = null;
    root.dispatchEvent(new CustomEvent('zr-ec:closed', { detail: { reason: reason || '' } }));
  }

  function joined() {
    save({ joined: Date.now() });
    hideBar();
    if (isOpen) {
      showView('done');
      var t = doneView.querySelector('[data-zr-ec-done-title]');
      try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
    } else {
      open({ view: 'done' });
    }
  }

  function showError(text) {
    var box = root.querySelector('[data-zr-ec-errors]');
    box.textContent = text || root.getAttribute('data-error-text') || '';
  }

  var bypass = false;
  function nativeSubmit() {
    bypass = true;
    HTMLFormElement.prototype.submit.call(form);
  }

  function onSubmit(e) {
    if (bypass || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[data-zr-ec-submit]');
    if (btn) btn.disabled = true;
    showError('');
    root.querySelector('[data-zr-ec-errors]').textContent = '';
    fetch(form.getAttribute('action') || '/contact', {
      method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' }
    }).then(function (r) {
      // Shopify's bot protection answers a challenge page (/challenge redirect, or a
      // 403 "Your connection needs to be verified"). fetch cannot pass it - hand the
      // POST to the browser so the shopper can, then the page returns with
      // customer_posted=true and init() shows the code.
      if (!r.ok || /\/challenge/.test(r.url)) { nativeSubmit(); return null; }
      return r.text().then(function (html) {
        var errText = '';
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var box = doc.querySelector('[data-zr-ec-errors]');
          errText = box ? box.textContent.replace(/\s+/g, ' ').trim() : '';
        } catch (x) { errText = ''; }
        if (errText) { showError(errText); return; }
        if (/customer_posted=true/.test(r.url) || /data-posted="true"/.test(html)) { joined(); return; }
        // 200 without a success marker = an answer we cannot read; let the browser post it.
        nativeSubmit();
      });
    }).catch(function () {
      nativeSubmit();
    }).then(function () { if (btn) btn.disabled = false; });
  }

  function copyCode(btn) {
    var code = root.querySelector('[data-zr-ec-code]').textContent.trim();
    var done = function () { btn.textContent = root.getAttribute('data-copied-label') || btn.textContent; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { legacyCopy(code); done(); });
    } else { legacyCopy(code); done(); }
  }
  function legacyCopy(text) {
    var t = document.createElement('textarea');
    t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing else to try */ }
    document.body.removeChild(t);
  }

  // On the return leg the homepage newsletter section also succeeds (same customer
  // form), and Boost lifts its "Thank you" into a colorbox lightbox (z-index 9999)
  // on top of the code. Ours already says thanks and shows the code: close that one.
  function closeThemeThanks() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var box = document.getElementById('colorbox');
      var thanks = box && box.querySelector('.subscribe-form-lightbox-response');
      if (thanks && visible(box)) {
        if (window.jQuery && window.jQuery.colorbox && window.jQuery.colorbox.close) window.jQuery.colorbox.close();
        else { var x = document.getElementById('cboxClose'); if (x) x.click(); }
        clearInterval(t);
      } else if (tries > 20) {
        clearInterval(t);
      }
    }, 150);
  }

  function autoTrigger() {
    var pageType = root.getAttribute('data-page-type') || '';
    if (!AUTO_PAGES.test(pageType) || /^\/(challenge|account|password)/.test(location.pathname)) return;
    var s = load();
    if (s === null || s.joined) return;
    var days = Number(root.getAttribute('data-dismiss-days')) || 14;
    if (s.dismissed && Date.now() - s.dismissed < days * DAY) return;
    var delayAttr = Number(root.getAttribute('data-delay'));
    var delay = (isNaN(delayAttr) ? 0 : delayAttr) * 1000;
    var pct = (Number(root.getAttribute('data-scroll')) || 50) / 100;
    var t0 = Date.now(), exitIntent = false, fired = false;
    var desktop = window.matchMedia && window.matchMedia('(pointer: fine)').matches && window.innerWidth >= 1024;
    if (desktop) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 >= 3000) exitIntent = true;
      });
    }
    function scrolled() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max < 200) return true;
      return window.pageYOffset / max >= pct;
    }
    var timer = setInterval(function () {
      if (fired || isOpen) return;
      var ready = exitIntent || (Date.now() - t0 >= delay && scrolled());
      if (!ready || consentOpen()) return;
      fired = true;
      clearInterval(timer);
      open({});
    }, 500);
  }

  function init() {
    root = document.querySelector('[data-zr-ec-popup]');
    var st = load();
    var barDays = 14;
    var bar = document.querySelector('[data-zr-ec-bar]');
    if (bar) barDays = Number(bar.getAttribute('data-dismiss-days')) || 14;
    if (st && (st.joined || (st.barHidden && Date.now() - st.barHidden < barDays * DAY))) hideBar();

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opener = t.closest('[data-zr-ec-open]');
      if (opener) { e.preventDefault(); open({ opener: opener }); return; }
      var dis = t.closest('[data-zr-ec-bar-dismiss]');
      if (dis) { e.preventDefault(); save({ barHidden: Date.now() }); hideBar(); return; }
      if (!root || !isOpen) return;
      if (t.closest('[data-zr-ec-close]')) { e.preventDefault(); close('click'); return; }
      var cp = t.closest('[data-zr-ec-copy]');
      if (cp) { e.preventDefault(); copyCode(cp); }
    });

    if (!root) return;
    dialog = root.querySelector('[role="dialog"]');
    formView = root.querySelector('[data-zr-ec-view="form"]');
    doneView = root.querySelector('[data-zr-ec-view="done"]');
    form = root.closest('form');
    // The footer group is a stacking context (position:relative; z-index:1), so a
    // fixed popup inside it paints under the header. Move the whole form (it holds
    // the popup and its inputs) to <body> so z-index 1500 means what it says.
    var host = form || root;
    if (host.parentNode !== document.body) document.body.appendChild(host);
    if (form) form.addEventListener('submit', onSubmit);

    if (root.getAttribute('data-posted') === 'true' || /[?&]customer_posted=true/.test(location.search)) {
      joined();
      closeThemeThanks();
      return;
    }
    if (root.getAttribute('data-errors') === 'true') { open({}); return; }
    autoTrigger();
  }

  window.ZrEmailPopup = {
    open: function () { open({}); },
    close: function () { close('api'); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
